import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import React from 'react';
import SvgIcon from './SvgIcon';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
var TelavoxIcon = function TelavoxIcon(props) {
  return /*#__PURE__*/_jsx(SvgIcon, _objectSpread(_objectSpread({}, props), {}, {
    viewBox: '0 0 24 24',
    children: /*#__PURE__*/_jsx("g", {
      id: "Telavox_Bug",
      stroke: "none",
      strokeWidth: "1",
      fill: "none",
      fillRule: "evenodd",
      children: /*#__PURE__*/_jsxs("g", {
        id: "Group",
        children: [/*#__PURE__*/_jsx("path", {
          d: "M12,12.48 C9.08404406,12.48 6.72,14.8438994 6.72,17.7603231 C6.72,20.6761006 9.08404406,23.04 12,23.04 C14.9166022,23.04 17.28,20.6761006 17.28,17.7603231 C17.28,14.8438994 14.9166022,12.48 12,12.48 L12,12.48 Z",
          id: "Path",
          fill: "#ffffff"
        }), /*#__PURE__*/_jsx("path", {
          d: "M24,5.28032142 C24,2.36373775 21.5935225,0 18.6256645,0 L5.3736812,0 C2.40582318,0 0,2.36373775 0,5.28032142 C0,8.1969051 2.40582318,10.56 5.3736812,10.56 L18.6256645,10.56 C21.5935225,10.56 24,8.1969051 24,5.28032142 L24,5.28032142 Z",
          id: "Path",
          fill: "#2DC659"
        })]
      })
    })
  }));
};
export default TelavoxIcon;